import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Users from "../../ducks/Users";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import "./index.css";
import ic_notification from "../../assets/img/ic_notification.png"
import ic_violations from "../../assets/img/ic_violations.png"
import { Spinner } from '../common/Spinner/index';
import { Link } from "react-router-dom";
import moment from 'moment';


import {
  Popover,
  PopoverBody,
  PopoverHeader
} from 'reactstrap';



class Notifications extends Component {

  constructor() {
    super();
    this.state = {
      popoverOpen: false,
      loading: true
    }
  }

  async getNotification() {

    const date = new Date();
      const startTime = moment(date)
        .hours(0)
        .minutes(0)
        .seconds(0);
      const endTime = moment(date)
        .hours(23)
        .minutes(59)
        .seconds(59);

        let body =   {
          startDate :  startTime,
          endDate :  endTime
        };
        await this.props.actions.getUserNotifications(body, 'loadMore');
    this.setState({
      ...this.state,
      loading: false
    })
  }

  async componentDidMount() {

    this.getNotification();

  }

  toggle() {
    // this.props.actions.viewNotifications();
    this.setState({
      ...this.state,
      popoverOpen: !this.state.popoverOpen
    });
  }
  gotoNotificationPage = (item) => {
    this.setState({ popoverOpen: false });
    this.props.history.push(`/notifications?date=${item.createdAt}&thing=${item.thing}&plate=${item.plateNumber}`);
  }
  render() {
    const loader = <Spinner key="1" />

    return (

      <span className="notification-bell">
        <a>
          <img src={ic_notification} onClick={this.toggle.bind(this)} alt="group" id="notificationPopup" />

          <Popover className="notif-popover" placement="bottom" isOpen={this.state.popoverOpen} target="notificationPopup" toggle={this.toggle.bind(this)}>

            <PopoverBody >
              {this.state.loading ? [loader] : <div>
                {this.props.notifications?.length > 0 ?

                  <div >

                    {this.props.notifications.map((item, index) => {

                      let icon = ic_violations;
                      

                      return (
                        <div key={index} className="notification-area" style={{ cursor: 'pointer' }} onClick={() => this.gotoNotificationPage(item)}>
                          <span><img src={icon} className="width36" alt="" /></span>
                          <span>
                            <div>{item.name}</div>

                            <span className="notif-p-popup">{item.thingName || ""}</span>

                            <span className="notif-p-popup margin-left55">
                              {moment(item.createdAt).format('DD-MMM-YY h:mm a') || 'N/A'}
                            </span>
                          </span>
                        </div>
                      
                      )
                    })}

                  </div> : <p className="no-notifications">No Notifications Yet!</p>}
              </div>}

            </PopoverBody>
            <PopoverHeader className="text-center">  <Link to="/notifications" className="text-center black-text bold-text">View All</Link></PopoverHeader>


          </Popover>


        </a>
        {this.props.notificationsCount > 0 ?
          <span>
            {this.props.notificationsCount > 99 ? "99+" : this.props.notificationsCount}

          </span>
          : ""}
      </span>
    )
  }
}

Notifications.propTypes = {};
Notifications.defaultProps = {};
const mapStateToProps = state => ({ notifications: state.users.notifications.notifications, notificationsCount: state.users.notifications.notificationsCount, hasMoreItems: state.users.hasMoreNotifications });

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Users.creators, dispatch)
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Notifications));
